import { mixins, Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import WithModel from './withModel';

@Options({})
export class BaseFormField extends mixins(WithModel) {
    
    @Prop() type: string;
    
    @Prop() labelKey: string;
    @Prop() labelText: string;
    @Prop() placeholderKey: number;
    @Prop() placeholderText: number;

    @Prop() required: boolean;
    @Prop() readonly: boolean;
    @Prop() tabIndex: number;

    @Prop() step: number;
    @Prop() min: number;
    @Prop() max: number;
    
    @Prop() asterisks: number;

    @Prop() list: any[];
    @Prop() itemLabel: string;
    @Prop() itemValue: string;

    @Prop() prefix: string;
    @Prop() checkboxIsSelected: boolean;
    @Prop() fileName: string;
    @Prop() validationCallback: (value: any) => boolean;

    validationClass: string = "";
    localPrefix: string = "";

    inputElement: HTMLElement = null;

    created(){
        this.localPrefix = this.prefix;
        this.validationClassRoutine(this.modelValue);
    }

    @Watch('prefix')
    changeLocalPrefix(){
        this.localPrefix = this.prefix;
    }
    
    @Watch('modelValue')
    onModelValueChangeBaseFormField(next, prev){
        this.validationClassRoutine(next);
        this.onModelValueChange(next, prev);
    }
    validationClassRoutine(val: any){
        this.validationClass = "";
        if(!this.required){
            if(!val)
                return;
        }
        if(this.validationCallback){
            this.validationClass = this.validationCallback(val) ? 'valid' : 'invalid';
        }
        if(this.required){
            if(val){
                this.validationClass = 'valid';
            } else {
                this.validationClass = 'invalid';
            }
        }
    }
}